import React from 'react';
import { useParams } from 'react-router-dom';
import Footer from './Footer';
import RemoteFFFooter from './RemoteFFFooter';
import { FF_FOOTER_SCRIPT_URL, FF_FOOTER_PRESET } from '~/app/settings';

/**
 * Map route locale to FFFooter region.
 * The bundle ships 'us' | 'cn'; everything else falls back to 'us'.
 *
 * @param {string} [locale]
 * @returns {'us' | 'cn'}
 */
export function mapLocaleToRegion(locale) {
  if (locale === 'cn') {
    return 'cn';
  }
  return 'us';
}

/**
 * AE locales keep the legacy footer: it carries the AE link set and the
 * RTL/LTR direction support that the CDN bundle (us/cn only) has no
 * equivalent for.
 *
 * @param {string} [locale]
 * @returns {boolean}
 */
export function isLegacyFooterLocale(locale) {
  return locale === 'ae_ar' || locale === 'ae_en';
}

/**
 * Shared footer entry: remote CDN FFFooter when REACT_APP_FF_FOOTER_SCRIPT_URL
 * is set, otherwise the legacy @ff/ui Footer.
 *
 * The remote footer renders the official site content, so the legacy
 * footerProps are not forwarded to it.
 */
export default function AppFooter(footerProps) {
  const params = useParams();
  const locale = params?.locale;
  const useRemoteFooter = Boolean(FF_FOOTER_SCRIPT_URL) && !isLegacyFooterLocale(locale);

  if (useRemoteFooter) {
    return (
      <RemoteFFFooter
        region={mapLocaleToRegion(locale)}
        preset={FF_FOOTER_PRESET || undefined}
        scriptUrl={FF_FOOTER_SCRIPT_URL}
      />
    );
  }

  return <Footer {...footerProps} />;
}
